export const OPENAI_COMPATIBLE_USAGE_HINT =
  "This API is OpenAI-compatible. Pass a placeholder API key; the proxy injects the real key from the connected app.";
